import TuneIcon from "@mui/icons-material/Tune";
import { useSetAtom } from "jotai";
import { type FunctionComponent, useCallback } from "react";

import { refineSearchDrawerAtom } from "scmp-app/components/search/search-result-panel/refine-search/drawer/atoms";

import { StyledButton } from "./styles";

type Props = {
  className?: string;
};

export const RefineSearchDrawerButton: FunctionComponent<Props> = ({ className }) => {
  const setDrawer = useSetAtom(refineSearchDrawerAtom);
  const handleClick = useCallback(() => {
    setDrawer({ isOpen: true });
  }, [setDrawer]);

  return (
    <StyledButton className={className} onClick={handleClick} type="button">
      <TuneIcon />
      Refine Search
    </StyledButton>
  );
};

RefineSearchDrawerButton.displayName = "RefineSearchDrawerButton";
